import { render } from "./AdditionalMenuRegister.vue?vue&type=template&id=6e3f2725&scoped=true"
import script from "./AdditionalMenuRegister.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdditionalMenuRegister.vue?vue&type=script&charset=utf-8&lang=js"

import "./AdditionalMenuRegister.vue?vue&type=style&index=0&id=6e3f2725&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3f2725"]])

export default __exports__